import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" noindex />
      <section className="min-h-[70vh] flex items-center justify-center py-16 bg-background">
        <div className="text-center max-w-md mx-auto px-4">
          <p className="text-6xl font-bold text-accent mb-4">404</p>
          <h1 className="text-2xl font-bold text-primary mb-3">Page Not Found</h1>
          <p className="text-gray-500 mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/" className="btn-primary">
              Go to Home
            </Link>
            <Link to="/products" className="btn-secondary">
              Browse Catalog
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
